<app-leveltwo [pageName]="'Institutional Property Tax Exemptions'">
    <div heading="General Info" class="General">
      <h3>{{'NonProfit.PageTitle'|translate}}</h3>

      <p>{{'NonProfit.Realandpersonal'|translate}}</p>
      <p>{{'NonProfit.MostNonProfit'|translate}} <b>{{'NonProfit.Require'|translate}}</b></p>
      <p><b>{{'NonProfit.APartialList'|translate}}</b></p>

      <div class="col-6">
        <ul>
          <li>{{'NonProfit.listitem1'|translate}}</li>
          <li>{{'NonProfit.listitem2'|translate}}</li>
          <li>{{'NonProfit.listitem3'|translate}}</li>
          <li>{{'NonProfit.listitem4'|translate}}</li>
          <li>{{'NonProfit.listitem5'|translate}}</li>
          <li>{{'NonProfit.listitem6'|translate}}</li>
          <li>{{'NonProfit.listitem7'|translate}}</li>
          <li>{{'NonProfit.listitem8'|translate}}</li>
          <li>{{'NonProfit.listitem9'|translate}}</li>
          <li>{{'NonProfit.listitem10'|translate}}</li>
          <li>{{'NonProfit.listitem11'|translate}}</li>
          <li>{{'NonProfit.listitem12'|translate}}</li>
          <li>{{'NonProfit.listitem13'|translate}}</li>
          <li>{{'NonProfit.listitem14'|translate}}</li>
          <li>{{'NonProfit.listitem15'|translate}}</li>
          <li>{{'NonProfit.listitem16'|translate}}</li>
          <li>{{'NonProfit.listitem17'|translate}}</li>
        </ul>
      </div>


      <p>*<i>{{'NonProfit.TheseExemptions'|translate}}</i></p>

      <p>{{'NonProfit.Pleasesee'|translate}}.</p>


      <p [innerHTML]="'NonProfit.Formorev2'|translate"></p>
      <!-- Major Exemptions<br>
      Phone: <b>(213) 974-3481</b><br>
      Email: <a href="mailto:exempt@assessor.lacounty.gov" target="_blank">exempt@assessor.lacounty.gov</a> -->




    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
